import { action, observable, reaction } from 'mobx';
import { noSpecialChars } from '../../../utils/noSpecialChars';
import { createGpSessionForProject } from '../../../business/EFH2/createGpSessionForProject';
import stores from 'cd-eft/models/Stores';
import { ProjectDataObject } from 'cd-eft/models/Projects/projectsLibrary';
import { ICreateActivityLogPOST } from 'cd-eft/models/Projects/createActivityLog';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import * as SETAPI from 'cd-eft/services/eftSetApi';
import { EftCreateProjectDto, StateCountyDto, StateDto, SpatialRefRequestDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { appConfig } from 'cd-eft/config/AppConfig';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { SurfaceDefRequest, SurfaceDefResponse } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { getSpatialRefByProject, getXYByStateCounty, getProjectionByLocation } from 'cd-eft/components/Projects/ProjectsLibrary/ProjectsLibraryVM';

const noRainfallStates = ['WA']; //['WY', 'ID', 'WA', 'MT'];
export interface ICreateProjectsComponent {
  projectClassId?: number;
}

const {
  projectsLibraryStore: libraryStore,
  efh2Store,
  designStore,
  pitDesignStore,
  padDesignStore,
  landLevelingDesignStore,
  surveyEngineeringStore,
  alignmentDesignStore,
  userProfileStore,
  waterwayDesignStore
} = stores.AppStore;

export class CreateProjectVM {
  private readonly _allowedProjectTypes: any[] = [];
  get allowedProjectTypes() {
    return this._allowedProjectTypes;
  }
  props: ICreateProjectsComponent;
  history;

  constructor(props: ICreateProjectsComponent, history) {
    reaction(
      () => this.createProjectForm.projectClassId,
      (projectClassId) => {
        this.setCoordinateSystemOptions(projectClassId);
      }
    );

    this.props = props;
    this.history = history;
    if (props.projectClassId !== undefined) {
      this.createProjectForm.projectClassId = props.projectClassId;
    }
    if (appConfig.navigationFlags.enableSingleWatershed)
      this._allowedProjectTypes.push({ value: '4', name: 'Hydrology Analysis' });
    if (userProfileStore.applicationFlags.enabledesign) this._allowedProjectTypes.push({ value: '1', name: 'Design' });
  }

  redirectCallback() {
    if (this.createProjectForm.projectClassId === 1) {
      this.history.replace(`/design/${this.newProjectId}/surface`);
    } else if (this.createProjectForm.projectClassId === 4) {
      this.history.push(`/analysis/hydrology/single-watershed/${efh2Store.projectsStore.currentProject.projectUuid}`);
    }
  }

  @observable coordinateSystemOptions: IOption[] = [];
  @observable selectedValues: ISelectedValues = {
    state: '',
    county: '',
    coordinateSystemType: ''
  };
  @observable newProjectId = '';
  @observable projectTitle: string = '';
  @observable projectClient: string = '';
  @observable projectType: number = 0;
  @observable latLong = {
    lat: 0,
    long: 0,
  };
  @observable createProjectForm: ICreateProjectForm = {
    currentUser: String(localStorage['username'] || 'Old McDonald'),
    projectTitle: '', // title
    projectClassId: 0, // BE defaults to 1 for all projects for now. Future: 1=design, 4=analysis-hydrology,
    client: '',
    practice: '',
    state: '',
    county: '',
    coordinateSystemType: ''
  };
  @observable createProjectionForm: ICreateProjectionForm = {
    coordinateType: '',
    createdBy: '',
    creationDate: '',
    deleted: 0,
    espg: '',
    lastChangeDate: '',
    lastChangedBy: '',
    projectUuid: '',
    projectionName: '',
    spatialRefId: 0,
    unit: '',
    wkid: '',
    zone: '',
  };
  // Help modal related vars
  @observable showHelpModal: boolean = false;
  @action.bound toggleHelpModal() {
    this.showHelpModal = !this.showHelpModal;
  }
  readonly helpModalContent = "Coordinate System Type Help Placeholder";
  readonly helpModalTitle = "Coordinate System Type";


  /*// This is subject to change
  @observable createProjectForm: ICreateProjectPOST = {
    projectName: '', // title
    projectApplicationUser: String(localStorage.getItem('username') || 'Old McDonald'),
    projectTypeName: '', // type
    designProjectApprover: '',
    farmlandId: 0, // client
    session: {
      stepCodeName: 'EFH2GIS-1',
      stagingWorksSpacePath: '',
      stagingDataCleaningStatus: '',
      noticeToUser: false,
      noticeToClean: false,
    },
    userpreference: JSON.stringify(stores.AppStore.userProfileStore.userPreferences),
  };*/
  @observable mapView;
  @observable disableCreateProject: boolean = true;

  @observable usStates: StateDto[] = [];
  @observable counties: StateCountyDto[] = [];
  @observable stateCountyResponse: StateCountyResponse | null = null;
  @observable selectedZone: string = '';
  @observable selectedUnit: string = '';


  @action.bound setCoordinateSystemOptions(projectClassId: number) {
    designStore.setLoader('Loading Coordinate System Type');
    if (projectClassId === 4) {
      this.coordinateSystemOptions = [
        { value: "WGS 1984 UTM", label: "WGS 1984 UTM", name: "WGS 1984 UTM" }
      ];
      this.selectedValues.coordinateSystemType = "WGS 1984 UTM";
      this.createProjectForm.coordinateSystemType = "WGS 1984 UTM";
      this.formValidation.coordinateSystemTypeValid = true;
    } else if (projectClassId === 1) {

      // The following line might be using in the future to avoid the hardcoded options
      // this.getCoordinateTypeList();
      this.coordinateSystemOptions = [
        { value: "NAD83(2011) UTM", label: "NAD83(2011) UTM", name: "NAD83(2011) UTM" }
      ];
      this.selectedValues.coordinateSystemType = '';
      this.formValidation.coordinateSystemTypeValid = true;
    } else {
      this.coordinateSystemOptions = [];
      this.selectedValues.coordinateSystemType = '';
    }
    designStore.setLoader('');
  }


  @action.bound handleCoordinateSystemChange<T>(value: T) {
    const selectedOption = this.coordinateSystemOptions.find(
      (option) => option.value === String(value)
    );
    libraryStore.pojectionByLocationData = [];
    this.selectedZone = '';
    if (selectedOption) {
      this.selectedValues.coordinateSystemType = selectedOption.value;
      this.createProjectForm.coordinateSystemType = selectedOption.value;
      this.validateField('coordinateSystemType', value);
    } else {
      this.selectedValues.coordinateSystemType = '';
      this.createProjectForm.coordinateSystemType = '';
      this.validateField('coordinateSystemType', '');
    }
  }

  @action.bound handleZoneNameInputChange(event) {
    this.selectedZone = event.target.value;
    this.validateField('zone', this.selectedZone);
  }

  //This function will be used to get the list of coordinate types from the backend
  /*   @action.bound async getCoordinateTypeList() {
      try {
        const response = await PRJAPI.ProjectionMetadataController.getCoordinateTypeListUsingGET();
        const data = response.data;
  
        // Filter out unwanted coordinate types
        const filteredData = data.filter((item: string) => item !== "NAD83 BLM" && item !== "WGS 1984 UTM");
  
        // Transform the filtered data into options format
        const options = filteredData.map((item: string) => ({
          value: item,
          label: item,
          name: item
        }));
  
        this.coordinateSystemOptions = options;
        MessageCenter.clearMessages();
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }
    } */

  @action.bound async getStates() {
    try {
      const response = await PRJAPI.StateCountyController.getAllStatesUsingGET();
      this.usStates = response.data;
      MessageCenter.clearMessages();
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }

  @action.bound async projectionByLocation() {
    if (this.selectedValues.coordinateSystemType !== '' && this.selectedValues.state !== '' && this.selectedValues.county !== '') {
      try {
        MessageCenter.clearMessages();

        await getProjectionByLocation(this.selectedValues.coordinateSystemType, this.selectedValues.state, this.selectedValues.county);
        if (this.createProjectForm.projectClassId === 4) {
          if (libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0) { this.formValidation.zoneValid = libraryStore.pojectionByLocationData.length === 1 }
        }
        if (this.createProjectForm.projectClassId === 1 && this.createProjectForm.coordinateSystemType !== '') {
          if (libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0) {
            this.formValidation.zoneValid = libraryStore.pojectionByLocationData.length === 1
          }
        }
        this.validateField('zone', this.selectedZone);
        const warningMsg = libraryStore.pojectionByLocationData[0]?.warningMsg;
        if (!this.formValidation.formValid && this.selectedValues.state === this.createProjectForm.state) {
          if (warningMsg) { MessageCenter.addWarning(warningMsg); }
          this.disableCreateProject = true;
        } else {
          this.disableCreateProject = false;
        }
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }
    }
  }
  @action.bound async getCountiesFromState(state) {
    this.disableCreateProject = true;
    if (state) {
      try {
        const response = await PRJAPI.StateCountyController.getCountiesByStateUsingGET(state);
        this.counties = response.data;

        // reset selection if not in counties
        const county = this.counties.find((d) => d.county_name === this.createProjectForm.county);
        if (county === undefined) {
          this.createProjectForm.county = '';
          const countyInput: any = document.getElementById('county');
          if (countyInput) {
            countyInput.value = '';
          }
        }
        MessageCenter.clearMessages();
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }
    }
  }

  @action.bound async changeStateSelection() {
    this.createProjectForm.county = '';
    const state = this.createProjectForm.state;
    if (state === '') {
      this.disableCreateProject = true;
      this.createProjectForm.county = '';
      this.selectedValues.county = '';
      const countyInput: any = document.getElementById('county');
      if (countyInput) {
        countyInput.value = '';
      }
      return;
    }
    await this.getCountiesFromState(state);
  }

  public isHydrologyNoRainfallState(): boolean {
    return ((this.createProjectForm.projectClassId === 4) &&
      (noRainfallStates.indexOf(this.createProjectForm.state) > (-1)));
  }

  public async showNoRainfallWarning(): Promise<void> {
    await MessageCenter.addWarningFromCode('Hydro_75', [
      {
        text: 'Continue',
        callback: () => {
          MessageCenter.clearMessages();
          this.handleSubmit2();
        }
      },
      {
        text: 'Cancel',
        callback: () => {
          MessageCenter.clearMessages();
        }
      },
    ]);
  }

  @action.bound async handleSubmit2() {
    if (!this.formValidation.formValid) {
      for (const field in this.createProjectForm) {
        const value = this.createProjectForm[field];
        this.validateField(field, value);
      }
      // If invalid - return and halt execution
      if (!this.formValidation.formValid) {
        return;
      }
    }

    MessageCenter.clearMessages();
    this.disableCreateProject = true;
    this.copyProjectValues();
    // not in API call
    // this.createProjectForm.farmlandId = Number(this.createProjectForm.farmlandId);

    const postJSON: EftCreateProjectDto = {
      currentUser: this.createProjectForm.currentUser,
      projectTitle: this.createProjectForm.projectTitle,
      projectClassId: this.createProjectForm.projectClassId,
      client: this.createProjectForm.client,
      practice: this.createProjectForm.practice,
      state: this.createProjectForm.state,
      county: this.createProjectForm.county,
    };
    try {
      const response = await PRJAPI.EftProjectController.createProjectUsingPOST(postJSON);
      let data = (response.data as unknown) as ProjectDataObject;

      if (data.projectUuid) {
        this.createProjectionForm.projectUuid = data.projectUuid;
        this.createProjectionForm.createdBy = data.createdBy;
        surveyEngineeringStore.reset();
        padDesignStore.reset();
        landLevelingDesignStore.reset();
        alignmentDesignStore.reset();
        pitDesignStore.reset();
        designStore.reset();
        waterwayDesignStore.reset();
        designStore.projectsStore.reset();
        efh2Store.reset();
        efh2Store.projectsStore.reset();

        if (this.createProjectForm.projectClassId === 4) {
          efh2Store.projectsStore.currentProject = data;
          data = efh2Store.projectsStore.currentProject;
          this.createActivityLog();
        } else if (this.createProjectForm.projectClassId === 1) {
          designStore.projectsStore.currentProject = data;
          data = designStore.projectsStore.currentProject;
          surveyEngineeringStore.resetTransformation();

          if (data.sessionList.length) {
            const p_sessionUuid = designStore.projectsStore.currentProject.sessionList[0].sessionUuid;
            if (designStore.projectsStore.currentProject.sessionList[0].sessionUuid) {
              await this.createSurface(p_sessionUuid);
              this.createActivityLog();
            }
          }
        }
        await this.createSpatialRef()
        await getSpatialRefByProject(data.projectUuid)
        await createGpSessionForProject(data);
        this.newProjectId = data.projectUuid;
        this.redirectCallback();
      }
      MessageCenter.clearMessages();
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      this.disableCreateProject = false;
    }
  }

  //create surface based on given sessionUuid
  @action.bound async createSurface(p_sessionUuid) {
    const postJSON: SurfaceDefRequest = {
      sessionUuid: p_sessionUuid,
      sessionResourceId: appConfig.tempHardCodes.sessionResource.sessionResourceId,
      surfaceDefTypeId: appConfig.tempHardCodes.surfaceDefType.surfaceDefTypeId,
      surfaceDefClassId: appConfig.tempHardCodes.surfaceDefClass.surfaceDefClassId,
      surfaceDefTitle: appConfig.tempHardCodes.surfaceDefTitle,
      srid: appConfig.tempHardCodes.wkid,
      zUnits: appConfig.tempHardCodes.zUnits,
      xMin: appConfig.tempHardCodes.xMin,
      xMax: appConfig.tempHardCodes.xMax,
      yMin: appConfig.tempHardCodes.yMin,
      yMax: appConfig.tempHardCodes.yMax,
      shape: appConfig.tempHardCodes.shape,
      surfaceJson: appConfig.tempHardCodes.surfaceJson,
    };

    try {
      const response = await SETAPI.SurfaceDefController.createSurfaceDefUsingPOST(postJSON);
      const data: SurfaceDefResponse = response['data'];
      if (data) {
        designStore.currentSurface.surfaceDefId = data.surfaceDefId!;
        designStore.currentSurface.surfaceDefTitle = data.surfaceDefTitle!;
      }
      designStore.hasSurface = true;
      MessageCenter.clearMessages();
    } catch (error) {
      designStore.hasSurface = false;
      MessageCenter.addError((error as Error).message);
    }
  }

  @action.bound async createSpatialRef() {
    let projectionData = libraryStore.pojectionByLocationData[0];
    if (libraryStore.pojectionByLocationData.length > 1) {
      projectionData = libraryStore.pojectionByLocationData.find((data) => data.zoneName === this.selectedZone);
    }
    if (!projectionData) {
      return;
    }

    let projectionName = projectionData.projectionName;

    if (this.createProjectForm.projectClassId === 4) {
      // a hack to set the initial Hydrology project projection
      const zoneName = projectionData.zoneName as string;
      projectionName = `WGS_1984_UTM_Zone_${zoneName}`;
      let zoneNumber = "";
      let prefix = "";
      if (zoneName.endsWith("N")) {
        zoneNumber = zoneName.replaceAll("N", "");
        prefix = "326";
      } else if (zoneName.endsWith("S")) {
        zoneNumber = zoneName.replaceAll("S", "");
        prefix = "327";
      }
      if (zoneNumber !== "") {
        if (zoneNumber.length < 2) {
          zoneNumber = `0${zoneNumber}`;
        }
        projectionData.esriWkid = `${prefix}${zoneNumber}`;
      }
    } else if (this.createProjectForm.projectClassId === 1) {
      const shouldAddFtIntl = !projectionName.includes('_Ft_Intl');
      projectionName = shouldAddFtIntl ? `${projectionName}_Ft_Intl` : projectionName;
    }
    const selectedZone = projectionData.zoneName;
    const postJSON: SpatialRefRequestDto = {
      coordinateType: this.selectedValues.coordinateSystemType,
      createdBy: this.createProjectionForm.createdBy,
      espg: projectionData.epsgCode,
      projectUuid: this.createProjectionForm.projectUuid,
      projectionName: projectionName,
      unit: this.selectedUnit,
      wkid: projectionData.esriWkid,
      zone: selectedZone,
    };

    // Check if any of the payload properties are undefined or empty
    if (Object.values(postJSON).some(value => value === undefined || value === '')) {
      return; // Stop the function execution
    }
    try {
      await PRJAPI.SpatialRefController.createSpatialRefUsingPOST(postJSON);
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }


  @action.bound async createActivityLog() {
    const postJSON: ICreateActivityLogPOST = {
      projUuid:
        this.createProjectForm.projectClassId === 1
          ? designStore.projectsStore.currentProject.projectUuid
          : efh2Store.projectsStore.currentProject.projectUuid,

      sessionUuid:
        this.createProjectForm.projectClassId === 1
          ? designStore.projectsStore.currentProject.sessionList[0].sessionUuid
          : efh2Store.projectsStore.currentProject.sessionList[0].sessionUuid,
      userName:
        this.createProjectForm.projectClassId === 1
          ? designStore.projectsStore.currentProject.createdBy
          : efh2Store.projectsStore.currentProject.createdBy,
      comment:
        this.createProjectForm.projectClassId === 1
          ? `Create Design project with the name ${designStore.projectsStore.currentProject.projectTitle}.`
          : `Create Analysis-Hydrology project with the name ${efh2Store.projectsStore.currentProject.projectTitle}.`,
      activityContent: 'Create Activity',
      appAccessed: 'SET',
      crudCode: 'Create',
      projectStatus: 'Started',
    };

    try {
      await SETAPI.ActivityLogController.createActivityLogUsingPOST(postJSON);

    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }

  @action.bound async handleInputChange(event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    this.createProjectForm[name] = value;
    if (name === 'state') {
      this.selectedValues.state = value;
    } else if (name === 'county') {
      this.selectedValues.county = value;
    }

    // if value is number keep it a number
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      value = +value;
    }
    this.validateField(name, value);

    if (name === 'state' || name === 'county') {
      libraryStore.pojectionByLocationData = []
      this.selectedZone = '';
    }
    // Call getXYByStateCounty() only if state and county are selected
    if (this.selectedValues.state && this.selectedValues.county) {
      await getXYByStateCounty(this.selectedValues.state, this.selectedValues.county);
      if (this.formValidation.formValid) { this.disableCreateProject = false; }
      else {
        this.disableCreateProject = true;
      }
    }
  }

  @action.bound async handleStateInputChange(event) {
    this.createProjectForm.county = '';
    this.selectedValues.county = '';
    this.counties = [];
    this.handleInputChange(event);
    await this.changeStateSelection();
    if (!this.selectedValues.state) {
      this.createProjectForm.county = '';
      this.selectedValues.county = '';
      libraryStore.pojectionByLocationData = [];
    }
  }

  @action.bound handleProjectClassIdChange(event) {
    const target = event.target;
    const value = parseInt(target.value);
    const name = target.name;
    const value1 = name === 'projectClassId' && isNaN(value) ? 0 : value;
    libraryStore.pojectionByLocationData = [];
    this.selectedZone = '';
    if (value1 === 1) {
      this.selectedUnit = 'Feet';
    } else if (value1 === 4) {
      this.selectedUnit = 'Meter';
    }
    this.createProjectForm[name] = value1;
    this.validateField(name, value1);
    if (this.selectedValues.state && this.selectedValues.county && this.formValidation.formValid) {
      this.disableCreateProject = false;
    } else {
      this.disableCreateProject = true;
    }
  }

  @observable formValidation = {
    formErrors: {
      projectTitle: '',
      projectClassId: '',
      coordinateSystemType: '',
      client: '',
      state: '',
      county: '',
      zone: '',
    },
    projectTitleValid: false,
    projectClassIdValid: false,
    clientValid: false,
    stateValid: false,
    countyValid: false,
    formValid: false,
    coordinateSystemTypeValid: false,
    zoneValid: true,
  };

  @action.bound validateField(fieldName, value) {
    // connects form field to validation table
    const keyValid = fieldName + 'Valid';
    let fieldValid = this.formValidation[keyValid];
    const fieldValidationErrors = this.formValidation.formErrors;

    switch (fieldName) {
      case 'projectTitle':
        // is required and no special chars
        fieldValid = value !== '' && noSpecialChars(value);
        fieldValidationErrors[fieldName] = fieldValid
          ? ''
          : 'Project Name is required and only numbers and letters are allowed';
        break;
      case 'projectClassId':
        // is required and value should not be 0
        fieldValid = value !== '' && value !== 0;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'Project Type is required';
        fieldValidationErrors.coordinateSystemType = '';
        if (this.createProjectForm.projectClassId === 4) { this.formValidation.zoneValid = false }
        break;
      case 'client':
        // is required and no special chars
        fieldValid = value !== '' && noSpecialChars(value);
        fieldValidationErrors[fieldName] = fieldValid
          ? ''
          : 'Client is required and only numbers and letters are allowed';
        break;
      case 'currentUser':
        fieldValid = value !== '';
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'Current User is required';
        break;
      case 'state':
        fieldValid = value !== '';
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'State is required';
        break;
      case 'county':
        fieldValid = value !== '';
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'County is required';
        break;
      case 'coordinateSystemType':
        if (this.createProjectForm.projectClassId === 4) {
          fieldValid = value !== '';
          fieldValidationErrors[fieldName] = fieldValid ? '' : 'Coordinate System Type is required';
        } else {
          fieldValid = true; // need refactor because when the coordinateSystemType(optional) is selected, unit, zone and project name need validation too.
          fieldValidationErrors[fieldName] = '';
        }
        break;
      case 'zone':
        if (this.createProjectForm.projectClassId === 4) {
          if (libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0) { fieldValid = libraryStore.pojectionByLocationData.length === 1 }
          else {
            fieldValid = value !== '';
            fieldValidationErrors[fieldName] = fieldValid ? '' : 'Zone is required';
          }
        } else {
          if (this.createProjectForm.projectClassId === 1 && this.createProjectForm.coordinateSystemType !== '') {
            if (libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0) { fieldValid = libraryStore.pojectionByLocationData.length === 1 }
            else {
              fieldValid = value !== '';
              fieldValidationErrors[fieldName] = fieldValid ? '' : 'Zone is required';
            }
          }
          else {
            fieldValid = true;
            fieldValidationErrors[fieldName] = '';
          }
        }
        break;
      default:
        break;
    }
    this.formValidation.formErrors = fieldValidationErrors;
    this.formValidation[keyValid] = fieldValid;
    this.validateForm(); // Update the form validity after validating the field
  }


  @action.bound validateForm() {
    let valid = true;
    for (const key in this.formValidation.formErrors) {
      if (!this.formValidation[key + 'Valid']) {
        valid = false;
      }
    }
    this.formValidation.formValid = valid;
    if (valid) { this.disableCreateProject = false }
    else {
      this.disableCreateProject = true;
    }
  }


  @action.bound errorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage.length === 0 ? '' : ' usa-input--error';
  }

  // @action.bound getLatLong() {
  //   const userPreferences = stores.AppStore.userProfileStore.getPreference('analysis-hydrology-project');
  //   if (userPreferences && userPreferences.poi_lat && userPreferences.poi_long) {
  //     this.latLong.lat = userPreferences.poi_lat;
  //     this.latLong.long = userPreferences.poi_long;
  //   } else {
  //     this.latLong.lat = 43.494465;
  //     this.latLong.long = -96.73699;
  //   }
  // }

  @action.bound getProjectType() {
    let projectTypeResult = 0;
    const userPreferences = stores.AppStore.userProfileStore.getPreference('new-project');

    if (userPreferences && userPreferences.project_type !== undefined) {
      projectTypeResult = userPreferences.project_type;
    } else {
      projectTypeResult = 0;
    }

    this.createProjectForm['projectClassId'] = projectTypeResult;
    this.validateField('projectClassId', projectTypeResult);
    return projectTypeResult;
  }

  // @action.bound getDesignProject() {
  //   // Will need to call a backend API () to get a list of design projects
  //   return '';
  // }

  // @action.bound showHideDesignSelection(classId) {
  //   if (classId == 4) {
  //     this.hideDesignProjects = false;
  //     this.hideSurfaceDetails = true;
  //   } else if (classId == 1) {
  //     this.hideDesignProjects = true;
  //     this.hideSurfaceDetails = false;
  //   } else {
  //     this.hideDesignProjects = true;
  //     this.hideSurfaceDetails = true;
  //   }
  // }

  @action.bound copyProjectValues() {
    efh2Store.basicDataForm.client = this.createProjectForm.client;
    efh2Store.basicDataForm.state = this.createProjectForm.state;
    efh2Store.basicDataForm.practice = this.createProjectForm.practice;
    efh2Store.basicDataForm.county = this.createProjectForm.county;
  }
}

interface ICreateProjectForm {
  currentUser: string;
  projectTitle: string;
  projectClassId: number;
  client: string;
  practice: string;
  state: string;
  county: string;
  coordinateSystemType: string;
}

interface ICreateProjectionForm {
  coordinateType: string;
  createdBy: string;
  creationDate: string;
  deleted: number;
  espg: string;
  lastChangeDate: string;
  lastChangedBy: string;
  projectUuid: string;
  projectionName: string;
  spatialRefId: number;
  unit: string;
  wkid: string;
  zone: string;
}


interface StateCountyResponse {
  stateCode: string;
  countyName: string;
  xmin: number;
  xmax: number;
  ymin: number;
  ymax: number;
  centroidx: number;
  centroidy: number;
}
interface IOption {
  name: string;
  value: string;
  label?: string;
}
interface ISelectedValues {
  state: string;
  county: string;
  coordinateSystemType: string
}

